import { get, post } from "../../../../services/request";

// Fetch Volume Trend Reports Dropdown List
export const getVolumeTrendReportsDDList = () => {
	return get('ExamData/GetVolumeTrendReportsDDList');
};
// export Strategic Demand Planner Reports with Pagination
export const exportStrategicReportsData = async (payload) => {
    try {
        const response = await get(`DemandTableBlockPlanning/ExportBlockDemandPlanningReport?BlockPlanningDemandTableID=${payload.BlockPlanningDemandTableID}`);
        return response;
    } catch (error) {
        throw error;
    }   
	
};
// Delete Strategic Demand Planner Report (row delete)
export const deleteStrategicDemandReport = async (id) => {
    try {
        const response = await post(`DemandTableBlockPlanning/DeleteReport?id=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};
export const updateBlockPlanningReportNote = (payload) => {
    return post('Common/UpdateBlockPlanningReportNote', payload);
};
export const getBlockCapacityTableReport = (payload) => post('DemandTableBlockPlanning/GetBlockCapacityTableReport', payload);
export const getBlockPlanningDemandInputWithPagination = (payload) => post('DemandTableBlockPlanning/GetBlockPlanningDemandInputWithPagination', payload);

export const getOnboardingSiteDemandPlannerLegend = () => get('SiteOnboardingPlanner/GetOnboardingSiteDemandPlannerLegend');
// get Strategic Demand Planner Reports with Pagination
export const getAllReportsWithPagination = (params) => {
  return post('DemandTableBlockPlanning/GetAllReportsWithPagination', params);
};
// POST: DemandTableBlockPlanning/DraftBlockDemandPlanningReport
export const draftBlockDemandPlanningReport = (payload) => {
  return post('DemandTableBlockPlanning/DraftBlockDemandPlanningReport', payload);
};

// POST: DemandTableBlockPlanning/PublishBlockDemandPlanning
export const publishBlockDemandPlanning = (payload) => {
  return post('DemandTableBlockPlanning/PublishBlockDemandPlanning', payload);
};
// GET SiteOnboardingPlanner/GetAllDropDownsList?ReportID={id}
export const getDemandInputFilterDDList = (reportId) => {
  return get(`SiteOnboardingPlanner/GetAllDropDownsList?ReportID=${reportId}`);
};
// strategicdemandservice.js
export const getWorkListByRPCEIds = (rpceIds) => {
  return post(`Common/GetWorkListByRPCEIds?rpceIds=${rpceIds}`);
};

// strategicdemandservice.js
export const getPracticesByWorklistIds = (worklistID) => {
    return get((`Common/GetPracticesByWorklistIds?worklistIds=${worklistID}`));
};
// strategicdemandservice.js
export const getSiteOnboardingPlanner = (payload) => {
  return post('DemandTableBlockPlanning/GetSiteOnboardingPlanner', payload);
};
export const getSiteOffboardingPlanner = (payload) => {
  return post('DemandTableBlockPlanning/GetDemandSiteOffboarding', payload);
};
export const getBlockPlanningDemandDailyWithPagination = (payload) => {
  return post("DemandTableBlockPlanning/GetBlockPlanningDemandDailyWithPagination", payload);
};
// strategicdemandservice.js
export const getBlockPlanningDemandQuarterlyWithPagination = (payload) => {
  return post(
    "DemandTableBlockPlanning/GetBlockPlanningDemandQuarterlyWithPagination",
    payload
  );
};

//Fetch Week and Quarter
export const GetWeekAndQuarterDetails = (fromMonthYear, toMonthYear) => {
  return get(`/Common/GetWeekQuarterByMonthYear?fromMonthYear=${fromMonthYear}&toMonthYear=${toMonthYear}`);
}
